export enum UserRole {
  USER = "user",
  CONTENT_ADMIN = "content admin",
  SYSTEM_ADMIN = "system admin",
  SYSTEM = "system",
}
